import React from "react";
import { GridBackdrop } from "./components/GridBackdrop";
import { ScrollProgress } from "./components/ScrollProgress";
import { TopBar } from "./components/TopBar";
import { Hero } from "./components/Hero";
import { VideoSection } from "./components/VideoSection";
import { ProblemSection } from "./components/ProblemSection";
import { CostCalculator } from "./components/CostCalculator/CostCalculator";
import { HowItWorks } from "./components/HowItWorks";
import { IncludedSection } from "./components/IncludedSection";
import { Differentiation } from "./components/Differentiation";
import { WhoItsFor } from "./components/WhoItsFor";
import { FoundingClient } from "./components/FoundingClient";
import { DiagnosisChecklist } from "./components/DiagnosisChecklist";
import { ApplicationWizard } from "./components/ApplicationWizard/ApplicationWizard";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { StickyBar } from "./components/StickyBar";
import { useDocumentMeta } from "./hooks/useDocumentMeta";
import { LeakChecklist } from "./components/LeakChecklist";
export function App() {
  useDocumentMeta();
  return <div lang="es" className="relative min-h-screen w-full overflow-x-clip bg-ink font-sans text-cream" data-id="element-0" data-mp="3rdkisa5iorpx">
      <ScrollProgress data-id="element-1" data-mp="4n7u7q58zd7" />
      <GridBackdrop data-id="element-2" data-mp="82k72sfnuax" />
      <div className="relative z-10" data-id="element-3" data-mp="2zl3cjn8vpa6d">
        <TopBar data-id="element-4" data-mp="2zm4xqkjlzd1t" />
        <main data-id="element-5" data-mp="2zmo5j8fjol24">
          <Hero data-id="element-6" data-mp="2zn6b4vo3kbmp" />
          <VideoSection data-id="element-7" data-mp="33mov9p83gioh" />
          <ProblemSection data-id="element-8" data-mp="33m5e4aq9pybi" />
          <WhoItsFor data-id="element-9" data-mp="33nghwajpr62m" />
          <CostCalculator data-id="element-10" data-mp="33oriy2lrxzq1" />
          <HowItWorks data-id="element-11" data-mp="38m1fs3bhtdnw" />
          <IncludedSection data-id="element-12" data-mp="38li77d7qg1mj" />
          <Differentiation data-id="element-13" data-mp="38k6w0sbyjrle" />
          <LeakChecklist data-id="element-14" data-mp="38o4fjf2g6l5t" />
          <FoundingClient data-id="element-15" data-mp="3dle3eqa6uorj" />
          <DiagnosisChecklist data-id="element-16" data-mp="3dlnukh6yz1yt" />
          <ApplicationWizard data-id="element-17" data-mp="3dirvuqnas99b" />
          <FAQ data-id="element-18" data-mp="nvssr1axyhud" />
          <FinalCTA data-id="element-19" data-mp="nwc1psim5vw9" />
        </main>
        <Footer data-id="element-20" data-mp="nvar1p5ifbf2" />
      </div>
      <StickyBar data-id="element-21" data-mp="suncq6knacg2" />
    </div>;
}